import React from 'react'
import { Button, Heading, Text } from '@plurall/elo'

import {
  messageWrapper,
  messageBlock,
  messageDenied,
  messageText,
  messageTitle,
} from './Hangouts.module.scss'

const { REACT_APP_ASSETS_URL } = process.env

export const Denied = () => (
  <div className={messageWrapper} >
    <div className={messageDenied} >
      <img alt='Acesso negado' src={`${REACT_APP_ASSETS_URL}/static/error-pages/images/denied.svg`} />
    </div>
    <div className={messageBlock}>
      <Heading className={messageTitle} size='big' >Você ainda não pode acessar aulas digitais mas falta pouco</Heading>
      <Text className={messageText}>
        Provavelmente, seu usuário de acesso ao Plurall é recente, então precisamos de até 24
        horas para criar sua conta no Hangouts Meets do Google. Se após este período você não
        conseguir acessar as aulas, entre em contato conosco pelo menu Suporte.
      </Text>
      <Button onClick={closeWindow}>Voltar para a tela inicial</Button>
    </div>
  </div>
)

const closeWindow = () => window.close()
